import { Component, OnInit } from '@angular/core';
import { AssetService } from '../services/asset.service';
import { AlertService } from 'app/shared/services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { LibraryAsset } from '../models/library-asset';
import { Location } from '@angular/common';

@Component({
  selector: 'dac-admin-view-asset',
  templateUrl: './admin-view-asset.component.html',
  styleUrls: ['./admin-view-asset.component.scss']
})
export class AdminViewAssetComponent implements OnInit {
  public hasLoaded:boolean;
  public asset:LibraryAsset
  public disableAsset:boolean = true;

  constructor(private route:ActivatedRoute, private assetService:AssetService, private alertService:AlertService, private location:Location) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assetId = params['assetId'];
      this.hasLoaded = false;
      this.assetService.getAsset(assetId).then((asset:LibraryAsset) => {
        this.hasLoaded = true;
        this.asset = asset;
      })
      .catch((error) => {
        console.error(error);
        if (error && error.status === 404 || error.status === 400) {
          this.alertService.error("404 This item could not be found");
        } else {
          this.alertService.error("There was a server error in loading this item.  Check your internet connection or contact support");
        }
      });
    });
  }

  public goBack() {
    this.location.back();
  }
  public shouldDisplayExercise() {
    return this.asset && this.asset.type == 'assignment';
  }

  public shouldDisplayArticle() {
    return this.asset && this.asset.type == 'article';
  }

}



// WEBPACK FOOTER //
// ./src/app/library-assets/admin-view-asset/admin-view-asset.component.ts